import React from 'react';
import './Input.css';

function Input({
  id,
  type = 'text',
  size = 'md',
  error = false,
  disabled = false,
  className = '',
  ...rest
}) {
  const classes = [
    'ui-input',
    size === 'sm' ? 'ui-input--sm' : '',
    error ? 'ui-input--error' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <input
      id={id}
      type={type}
      className={classes}
      disabled={disabled}
      aria-invalid={error || undefined}
      {...rest}
    />
  );
}

export default Input;
